import theme from '@/theme';
import styled from '@emotion/styled';
import { TextField as MuiTextField } from '@mui/material';

const TextField = styled(MuiTextField)`
    & .MuiInputBase-root {
        background-color: #fff !important;
        border-radius: 1rem;
    }

    fieldset {
        border-color: ${theme.colors.black[300]};
    }

    & .Mui-focused fieldset.MuiOutlinedInput-notchedOutline {
        border-color: ${theme.colors.black.main};
        border-width: 1px !important;
    }

    & .Mui-error fieldset.MuiOutlinedInput-notchedOutline {
        border-color: ${theme.colors.error[650]};
    }

    & .MuiFormHelperText-root {
        margin-top: -3px;
        margin-bottom: 8px;
        font-size: 1.4rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: ${theme.colors.black.main};
        border-color: ${theme.colors.black[300]};
    }

    fieldset:-webkit-autofill,
    fieldset:-webkit-autofill:hover,
    fieldset:-webkit-autofill:focus,
    fieldset:-webkit-autofill:active,
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        background-color: white !important;
        -webkit-box-shadow: 0 0 0 1000px white inset !important;
    }
`;

export default TextField;
